import { Spinner } from '@/components/generic';
import { useTranslation } from 'react-i18next';

export const LoadingStatus = ({
  onlySpinner = false,
}: {
  onlySpinner?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='w-min flex justify-center items-center rounded-2xl overflow-hidden'>
        <Spinner className='bg-transparent' />
      </div>
      {!onlySpinner && (
        <>
          <div className='mb-4 text-h4 max-md:text-h5 text-t-primary'>
            {t('common.processing_request')}
          </div>
          <div className='mb-8 text-body-2 font-medium text-t-tertiary'>
            {t('common.processing_request_description')}
          </div>
        </>
      )}
    </>
  );
};
